
















































import { Component, Vue, Watch } from "vue-property-decorator";
import { RevistasService, PaginaRevista } from "@/services/revistas.service";
import Loading from "@/shared/components/loading.vue";
import Modal from "@/shared/components/modal.vue";
import { fileToBase64 } from "@/shared/utils/utils";
import { required } from "@/shared/validators";

@Component({
  components: {
    Loading,
    Modal,
  },
})
export default class AdicionarPaginaRevista extends Vue {
  paginaRevista: PaginaRevista = {} as PaginaRevista;
  arquivoImagem: File | null = null;
  idRevista = "";
  valid = false;
  loading = false;

  rules = {
    imagem: [required()],
    numeroPagina: [required()],
  };

  required = (v: any) => {
    return !!v || "Campo obrigatório";
  };

  @Watch("arquivoImagem")
  onArquivoChange() {
    if (this.paginaRevista) {
      this.paginaRevista.imagemCompleta = URL.createObjectURL(
        this.arquivoImagem
      );
    }
  }

  async salvarPaginaRevista() {
    this.loading = true;
    const form = this.$refs.form as any;

    if (form.validate()) {
      if (this.arquivoImagem && this.paginaRevista) {
        const base64 = await fileToBase64(this.arquivoImagem);
        this.paginaRevista.idRevista = this.idRevista;
        await RevistasService.adicionarPaginaRevista(
          this.paginaRevista,
          base64
        );
      }
      this.fechar();
    }
    this.loading = false;
  }

  fechar() {
    const modal = this.$refs.modal as Modal;
    modal.close(false);
  }

  public async adicionarPaginaRevista(idRevista: string) {
    const modal = this.$refs.modal as Modal;
    const p = modal.open();

    this.idRevista = idRevista;

    return p;
  }
}
